import Types from '../types';

const initialState = {
  isGettingAnnouncement: false,
  isCreatingAnnouncement: false,
  isUpdatingAnnouncement: false,
  isDeletingAnnouncement: false,
};

export default (reducerState = initialState, action) => {
  switch (action.type) {
    case Types.GET_ANNOUNCEMENT_START:
      return {
        ...reducerState,
        isGettingAnnouncement: true,
      };
    case Types.CREATE_ANNOUNCEMENT_START:
      return {
        ...reducerState,
        isCreatingAnnouncement: true,
      };

    case Types.UPDATE_ANNOUNCEMENT_START:
      return {
        ...reducerState,
        isUpdatingAnnouncement: true,
      };

    case Types.DELETE_ANNOUNCEMENT_START:
      return {
        ...reducerState,
        isDeletingAnnouncement: true,
      };

    case Types.GET_ANNOUNCEMENT_END:
      return {
        ...reducerState,
        isGettingAnnouncement: false,
      };

    case Types.CREATE_ANNOUNCEMENT_END:
      return {
        ...reducerState,
        isCreatingAnnouncement: false,
      };

    case Types.UPDATE_ANNOUNCEMENT_END:
      return {
        ...reducerState,
        isUpdatingAnnouncement: false,
      };

    case Types.DELETE_ANNOUNCEMENT_END:
      return {
        ...reducerState,
        isDeletingAnnouncement: false,
      };

    default:
      return reducerState;
  }
};
